import React, { useCallback } from 'react';
import { AsyncRenderedRemote } from '../async-rendered-remote';
import { selectedFiltersMapState } from './utils';
import { DeletableFavoriteAddressType } from 'types/favorite-address';
import { useStoreon } from 'storeon/react';
import { State } from 'store/types';
import { getRemoteWidget } from 'api';
import { getCheckoutInfo } from 'common/utils/checkout-info';

const DELIVERY_METHODS_MAP_MODAL_WIDGET_ID = 'delivery-methods-map-modal';
const DELIVERY_METHODS_MAP_MODAL_WIDGET_NAME = 'checkout/delivery-methods-map-modal';

interface DeliveryMethodsMapModalRemoteProps {
  visible: boolean;
  regionId: string;
  onRemoteClose: () => void;
  onRemoteApply: (event: unknown) => void;
  selectedDeliveryType: CheckoutMapDeliveryType;
  selectedFilters: DeletableFavoriteAddressType | undefined;
}

export type CheckoutMapDeliveryType = 'DELIVERY' | 'PICKUP';

export const DeliveryMethodsMapModalRemote = ({
  visible,
  onRemoteClose,
  regionId,
  onRemoteApply,
  selectedDeliveryType,
  selectedFilters,
}: DeliveryMethodsMapModalRemoteProps) => {
  const { orchestratorHost, useCredentials, requestID, apiKey } = useStoreon<State>(
    'orchestratorHost',
    'useCredentials',
    'requestID',
    'apiKey',
  );
  const loadRemoteWidget = useCallback(() => {
    return getRemoteWidget(DELIVERY_METHODS_MAP_MODAL_WIDGET_NAME, {
      orchestratorHost,
      useCredentials,
      requestID,
      apiKey,
    });
  }, [apiKey, orchestratorHost, requestID, useCredentials]);

  const getHomeDeliveryParams = () => {
    const checkoutInfo = getCheckoutInfo();
    if (selectedDeliveryType === 'DELIVERY' && checkoutInfo?.address) {
      const { address, typeOfLift, privateHouse } = checkoutInfo;
      return {
        address,
        typeOfLift,
        isPrivateHouse: privateHouse,
      };
    }
  };

  return (
    <AsyncRenderedRemote
      id={DELIVERY_METHODS_MAP_MODAL_WIDGET_ID}
      widgetName={DELIVERY_METHODS_MAP_MODAL_WIDGET_NAME}
      loadWidget={loadRemoteWidget}
      data={{
        visible,
        onClose: onRemoteClose,
        onApply: onRemoteApply,
        regionId,
        showFilters: true,
        selectedDeliveryType,
        selectedFilters: [selectedFiltersMapState(selectedFilters)],
        ...getHomeDeliveryParams(),
      }}
    />
  );
};
